import React from 'react';
import PropTypes from 'prop-types';
import MaterialTextField from 'shared/components/connectedTextField/c/materialTextField/MaterialTextField';
import MaterialNumberField from 'shared/components/connectedTextField/c/materialNumberField/MaterialNumberField';

const inputStyle = { width: '50%', display: 'block' };

class AllocationUnitEditor extends React.Component {
  constructor(props){
    super(props);
    const { id, name, description, unitCount, unitCountAvailable } = props.allocationUnit;
    this.state = {
      allocationUnit: {
        id,
        name,
        description,
        unitCount,
        unitCountAvailable
      },
      minAmountValue: props.minAmountValue
    };
  }

  handleInputChange = (ev, value) => {
    const target = ev.target;
    this.props.onChangeField(target.name, value);
    this.setState(oldState => ({
      allocationUnit: { ...oldState.allocationUnit, [target.name]: value }
    }));
  };

  render() {
    const { allocationUnit, minAmountValue } = this.state;

    return (
      <div>
        <MaterialTextField
          name={ 'name' }
          label={ 'Name' }
          value={ allocationUnit.name }
          onChange={ this.handleInputChange }
          fullWidth={ false }
          style={ inputStyle }
          disabled={ !this.props.isCreation }
          required
        />
        <MaterialTextField 
          name={ 'description' }
          label={ 'Description (Optional)' }
          value={ allocationUnit.description }
          onChange={ this.handleInputChange }
          fullWidth={ false }
          style={ inputStyle }
        />
        <MaterialNumberField 
          name={ 'unitCount' }
          label={ 'Unit Count' }
          value={ allocationUnit.unitCount }
          onChange={ this.handleInputChange }
          fullWidth={ false }
          style={ inputStyle }
          errorText={ allocationUnit.unitCount < minAmountValue ? `Allocation Unit is being used, unit count should be greater than or equal to ${minAmountValue}` : null }
          required
        />
      </div>
    );
  }
}

AllocationUnitEditor.propTypes = {
  onChangeField: PropTypes.func.isRequired,
  allocationUnit: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    description: PropTypes.string,
    ifValue: PropTypes.string,
    thenValue: PropTypes.string,
    unitCountAvailable: PropTypes.number
  }).isRequired,
  isCreation: PropTypes.bool.isRequired,
  minAmountValue: PropTypes.number
};

export default AllocationUnitEditor;



// WEBPACK FOOTER //
// ./src/components/manageAllocationUnits/comp/allocationUnitEditor/AllocationUnitEditor.js